import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './EsdpMap.css'
import { GetTopicNavigationInfoByPathName } from './common/TabNavigation'

import Insights from '@healthwise-ui/content/Insights'
import translation from '@healthwise-ui/core/Translation'
import Footer from '@healthwise-ui/core/Footer'
import NavigationHeading from './NavigationHeading'
import TabGroup from '@healthwise-ui/core/TabGroup'
import Tab from '@healthwise-ui/core/Tab'
import CreditsAndReferences from '@healthwise-ui/content/CreditsAndReferences'
import StandardDisclaimer from './StandardDisclaimer'
import LoadingIndicator from '@healthwise-ui/core/LoadingIndicator'

class EsdpMap extends Component {
  constructor(props) {
    super(props)

    this.handleTopicTabClick = this.handleTopicTabClick.bind(this)

    this.lastPageViewed = false
    this.currentTopic = ''

    this.insights = new Insights()
    this.insights.setConfigOption('applicationName', 'esdp')
    this.insights.setConfigOption('application', 'esdp')
    this.insights.setConfigOption('product', props.product)
  }

  componentDidMount() {
    this.props.loadMap(this.props.mapId)
    this.props.updateStatus('In-Progress')
    this.setDocumentTitle()
  }

  componentWillReceiveProps(nextProps) {
    this.setInitialState()
    const currentTopic = GetTopicNavigationInfoByPathName(
      nextProps.navigationInfo,
      window.location.pathname
    )
    this.currentTopic = currentTopic.title
    this.setDocumentTitle(currentTopic)
    this.setVisitedState(this.props.params.topicId)
  }

  componentDidUpdate() {
    // focus the active tab on page load
    const tab = document.querySelector('.hw-tab-is-active');
    if (tab && typeof tab.focus === 'function') {
      tab.focus()
    }
  }

  setDocumentTitle(topic) {
    const esdpMap = this.props.esdpMap

    if (
      esdpMap &&
      esdpMap.title &&
      esdpMap.title.consumer &&
      document &&
      document.title
    ) {
      document.title = topic.title
        ? `${esdpMap.title.consumer} - ${topic.title}`
        : esdpMap.title.consumer
      this.recordPageView(topic.id)
    } else {
      document.title = translation(this.props.localization, 'Loading')
    }
  }

  recordPageView(topicId) {
    const props = this.props
    const topic = props.esdpMap.topics.filter(function(topic) {
      return topic.id === topicId
    })[0]

    // only send pageViewed once
    if (this.lastPageViewed !== topic.id) {
      this.insights.trackEvent({
        pageName: document.title,
        eventName: 'pageViewed',
        documentHwid: topic.id,
        documentType: 'esdp',
        documentTitle: topic.topics[0].title.consumer,
        docLanguage: topic.topics[0].lang,
        sectionHwid: 'tab',
        sectionTitle: topic.title.consumer
      })
    }

    this.lastPageViewed = topic.id
  }

  getTopicLocation(mapId, localization, topicId) {
    return `/${mapId}/${localization}/${topicId}`
  }

  isAlreadyVisited(topicId) {
    let toReturn = false

    this.props.navigationInfo.forEach(function(navItem) {
      if (navItem.id === topicId && navItem.visited) {
        toReturn = true
      }
    })

    return toReturn
  }

  setInitialState() {
    const { mapId, localization, children, esdpMap, router } = this.props
    if (
      children === null &&
      esdpMap !== null &&
      Array.isArray(esdpMap.topics) &&
      esdpMap.topics[0]
    ) {
      const topicId = esdpMap.topics[0].id
      this.setVisitedState(topicId)
      const topicLocation = this.getTopicLocation(mapId, localization, topicId)
      router.replace(topicLocation)
    }
  }

  setVisitedState(topicId) {
    if (!this.isAlreadyVisited(topicId)) {
      this.props.setVisitedNav(topicId)
    }
  }

  handleTopicTabClick(event, topicLocation, topicId) {
    event.preventDefault()

    this.insights.trackEvent({
      pageName: document.title,
      eventName: 'pageAction',
      actionName: 'navigation',
      actionContext: this.currentTopic
    })

    this.setVisitedState(topicId)
    this.props.router.push(topicLocation)
  }

  handleKeyUp(e, prevTab, nextTab) {
    switch(e.which) {
      case 37:
        return this.props.router.push(prevTab);
      case 39:
        return this.props.router.push(nextTab);
      default:
        return;
    }
  }

  createTopicTab(topic, index, topics) {
    const { mapId, localization } = this.props
    const navItems = this.props.esdpMap.navigation.topics
    const summaryTabId = navItems[navItems.length - 1].id
    const summaryEnabled = this.props.appMeta.summaryTabEnabled
    const isDisabled =
      !summaryEnabled && topic.id === summaryTabId
      
    const topicLocation = this.getTopicLocation(mapId, localization, topic.id)
    const topicLink = this.props.router.createHref(topicLocation)
    const isActive = this.props.router.isActive(topicLocation)
    const isAlreadyVisited = this.isAlreadyVisited(topic.id)

    let targetIndex = (index - 1 >= 0) ? index-1 : topics.length-1;
    if (!summaryEnabled && topics[targetIndex].id === summaryTabId) { // handle disabled, not elegant for multiple disabled tabs but esdp only has summary 
      targetIndex--
    }
    const prevTopic = topics[targetIndex];
    const prevTabLink = this.getTopicLocation(mapId, localization, prevTopic.id);
    
    targetIndex = (index + 1 <= topics.length - 1) ? index+1 : 0;
    if (!summaryEnabled && topics[targetIndex].id === summaryTabId) { 
      targetIndex = 0
    }
    const nextTopic = topics[targetIndex]
    const nextTabLink = this.getTopicLocation(mapId, localization, nextTopic.id);

    const onClick = isDisabled
      ? event => {
          event.stopPropagation()
          event.preventDefault()
        }
      : event => this.handleTopicTabClick(event, topicLocation, topic.id)
    
    return (
      <Tab
        key={topic.id}
        onKeyUp={(e) => this.handleKeyUp(e, prevTabLink, nextTabLink)}
        href={topicLink}
        onClick={onClick}
        isActive={isActive}
        tabIndex={isActive ? null : '-1'}
        aria-current={isActive ? 'step' : 'false'}
        visited={isAlreadyVisited}
        disabled={isDisabled}
      >
        {topic.title.consumer}
      </Tab>
    )
  }

  createTopicTabs(topics) {
    return topics.map((topic, index, topics) => this.createTopicTab(topic, index, topics))
  }

  render() {
    var { esdpMap } = this.props

    if (esdpMap !== null) {
      const topics = esdpMap.topics
      const legal = Object.assign(
        {
          logoUrl: null,
          copyrightText: null,
          disclaimerText: null,
          yourUseOfThisInformationHtml: null,
          toLearnMoreHtml: null
        },
        esdpMap.legal
      )
      const credits = esdpMap.credits
      const references = esdpMap.worksConsulted
      const asOfDate = esdpMap.certifiedDate
      const appRoot = esdpMap.applicationUrl
      const onSelection = function(fontSize) {
        const _guid = esdpMap.id
        const _root = appRoot
        const _lang = esdpMap.lang
        const newPath =
          _root + '/Print/Esdp/' + _lang + '/' + _guid + '/' + fontSize
        window.open(newPath, '_blank')
      }

      if (topics != null) {
        const tabs = this.createTopicTabs(topics)

        return (
          <div className={styles.container}>
            <NavigationHeading onSelection={onSelection}>
              <TabGroup>{tabs}</TabGroup>
            </NavigationHeading>
            {this.props.children}
            <Footer>
              <div className={styles.credits_wrapper}>
                <CreditsAndReferences
                  id="hw-esdp-credits-and-references"
                  credits={credits}
                  references={references}
                  asOfDate={asOfDate}
                />
              </div>
              <StandardDisclaimer
                logoSrc={legal.logoUrl}
                copyright={legal.copyrightText}
                disclaimer={legal.disclaimerText}
                externalHtml={legal.yourUseOfThisInformationHtml}
                learnMoreHtml={legal.toLearnMoreHtml}
              />
            </Footer>
          </div>
        )
      } else {
        return <div>Missing topics</div>
      }
    } else {
      return (
        <div>
          <LoadingIndicator />
        </div>
      )
    }
  }
}

EsdpMap.defaultProps = {
  esdpMap: null,
  product: 'communicate'
}

EsdpMap.propTypes = {
  children: PropTypes.element,
  appMeta: PropTypes.shape({
    summaryTabEnabled: PropTypes.bool.isRequired
  }),
  esdpMap: PropTypes.shape({
    navigation: PropTypes.shape({
      topics: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired
        })
      ).isRequired
    }),
    title: PropTypes.shape({
      consumer: PropTypes.string
    }).isRequired
  }),
  navigationInfo: PropTypes.array.isRequired,
  params: PropTypes.object,
  loadMap: PropTypes.func.isRequired,
  updateStatus: PropTypes.func.isRequired,
  setVisitedNav: PropTypes.func.isRequired,
  localization: PropTypes.string.isRequired,
  mapId: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
  router: PropTypes.object
}

export default EsdpMap



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/EsdpMap.js